<template>
  <div>
    <location />
    <div class="page wrap-1200">
      <h3 class="subtitle">{{ shopinfo.shopname }}</h3>
      <GmapMap
        v-if="shopinfo.maploc2 && shopinfo.maploc1"
        :center="{
          lat: parseFloat(shopinfo.maploc2),
          lng: parseFloat(shopinfo.maploc1),
        }"
        :zoom="15"
        map-type-id="roadmap"
        style="width: 100%; height: 300px"
      >
        <GmapMarker
          :position="{
            lat: parseFloat(shopinfo.maploc2),
            lng: parseFloat(shopinfo.maploc1),
          }"
          :clickable="true"
          :draggable="false"
          @click="
            center = {
              lat: parseFloat(shopinfo.maploc2),
              lng: parseFloat(shopinfo.maploc1),
            }
          "
        />
      </GmapMap>

      <div
        v-else
        style="
          width: 100%;
          height: 300px;
          background: #eee;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        지도를 불러오는 중입니다...
      </div>

      <div class="row row-cols-1 g-0 table-type header-col p-keep text-break">
        <div class="col col-sm-4 col-md-2">
          {{ $t("title.common.location") }}
        </div>
        <div class="col col-sm-8 col-md-4 shop-name">
          {{ shopinfo.shopname }}
        </div>
        <div class="col col-sm-4 col-md-2">
          {{ $t("title.common.location_type") }}
        </div>
        <div class="col col-sm-8 col-md-4">
          {{
            shopinfo.type_fk == 1
              ? $t("text.find_location.franchising_shop")
              : $t("text.find_location.corporate_owned_shop")
          }}
        </div>

        <div class="col col-sm-4 col-md-2">
          {{ $t("title.common.address") }}
        </div>
        <div class="col col-sm-8 col-md-4">
          {{ shopinfo.address }} {{ shopinfo.city }}
        </div>
        <div class="col col-sm-4 col-md-2">
          {{ $t("title.common.post_code") }}
        </div>
        <div class="col col-sm-8 col-md-4 d-flex align-items-center">
          {{ shopinfo.zipcode || $t("text.common.unregistered") }}
        </div>

        <div class="col col-sm-4 col-md-2">{{ $t("title.common.phone") }}</div>
        <div class="col col-sm-8 col-md-4">
          {{ shopinfo.phone || $t("text.common.unregistered") }}
        </div>
        <div class="col col-sm-4 col-md-2">{{ $t("title.common.fax") }}</div>
        <div class="col col-sm-8 col-md-4">
          {{ shopinfo.fax || $t("text.common.unregistered") }}
        </div>

        <div class="col col-sm-4 col-md-2">{{ $t("title.common.email") }}</div>
        <div class="col col-sm-8 col-md-4 d-flex align-items-center">
          <a
            :href="'mailto:' + shopinfo.email"
            target="_blank"
            class="text-decoration-underline more"
            v-if="shopinfo.email"
          >
            {{ shopinfo.email }}
          </a>

          <a v-else>
            {{ $t("text.common.unregistered") }}
          </a>
        </div>
        <div class="col col-sm-4 col-md-2">
          {{ $t("title.common.homepage") }}
        </div>
        <div class="col col-sm-8 col-md-4 d-flex align-items-center">
          <a
            :href="shopinfo.website"
            target="_blank"
            class="text-decoration-underline more"
            v-if="shopinfo.website"
          >
            {{ shopinfo.website }}
          </a>
          <a v-else>
            {{ $t("text.common.unregistered") }}
          </a>
        </div>

        <div class="col col-sm-4 col-md-2 border-bottom-md-0">
          {{ $t("title.membership.locker_count") }}
        </div>
        <div
          class="col col-sm-8 col-md-4 d-flex align-items-center border-bottom-md-0"
        >
          {{ shopinfo.locker_cnt || $t("text.common.unregistered") }}
        </div>
        <div class="col col-sm-4 col-md-2 border-bottom border-bottom-sm-0">
          {{ $t("title.common.simulator_count") }}
        </div>
        <div class="col col-sm-8 col-md-4 d-flex align-items-center">
          {{ shopinfo.systemcnt | comma }}
        </div>
      </div>

      <div class="btn-bottom-wrapper">
        <b-button
          size="xl"
          variant="outline-primary"
          :aria-label="$t('button.common.list')"
          @click="
            $router.push({
              name: 'Stores',
              query: {
                searchtype: $route.query.searchtype,
                searchname: $route.query.searchname,
              },
            })
          "
          >{{ $t("button.common.list") }}</b-button
        >

        <!-- <b-button
          size="xl"
          variant="primary"
          type="submit"
          @click="reservation()"
          :aria-label="$t('button.common.reservation')"
          >{{ $t("button.common.reservation") }}</b-button
        > -->
      </div>
    </div>
    <b-toast
      id="toast-require-login"
      toaster="position-fixed top-50 start-50 translate-middle"
      no-close-button
      no-auto-hide
      solid
      body-class="p-4 text-center"
    >
      <div class="avatar avatar-lg mt-2 bg-orange border-0">
        <h3 class="material-icons text-white">person</h3>
      </div>
      <h6 class="sub-title mt-3 mb-2">{{ $t("text.common.require_login") }}</h6>
      <p class="pt-1">{{ $t("text.common.go_login_page") }}</p>
      <div class="btn-bottom-wrapper mt-3">
        <b-button
          size="sm"
          variant="outline-secondary"
          :aria-label="$t('button.common.cancel')"
          @click="$bvToast.hide('toast-require-login')"
        >
          {{ $t("button.common.cancel") }}
        </b-button>
        <b-button
          size="sm"
          variant="secondary"
          :aria-label="$t('button.common.login')"
          @click="goToLogin"
        >
          {{ $t("button.common.login") }}
        </b-button>
      </div>
    </b-toast>

    <b-modal
      id="modal-reservation"
      ref="modal-reservation"
      size="md"
      centered
      scrollable
      no-close-on-backdrop
      footer-class="btn-bottom-wrapper"
    >
      <template #modal-header>
        <h3>{{ $t("title.common.reservation") }}</h3>
        <b-button
          variant="close"
          :aria-label="$t('button.common.close')"
          @click="$bvModal.hide('modal-reservation')"
        >
        </b-button>
      </template>
      <template v-if="reservation_flag == '1'">
        <p class="modal-subtitle lh-sm">
          {{ $t("title.common.reservation") }}
          {{ $t("title.common.Information") }}
        </p>
        <b-form
          class="filter-group row row-cols-sm-auto g-2 justify-content-end"
        >
          <div class="row g-0 table-type header-col p-keep">
            <div class="col-sm-4">
              <span>{{ $t("title.common.nickname") }}</span>
            </div>
            <div class="col-sm-8">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  readonly
                  v-model="form.nickname"
                  required
                />
              </div>
            </div>

            <div class="col-sm-4">
              <span>{{ $t("title.common.email") }}</span>
            </div>
            <div class="col-sm-8 d-flex flex-column flex-sm-row">
              <input type="text" name="email" v-model="form.email" readonly />
            </div>
            <div class="col-sm-4">
              <span>{{ $t("title.common.peoples") }}</span>
            </div>
            <div class="col-sm-8 d-flex flex-column flex-sm-row">
              <select id="people" v-model="form.people">
                <option value="0" disabled>
                  {{ $t("title.common.peoples") }}
                </option>
                <option
                  v-for="(val, index) in [1, 2, 3, 4, 5, 6]"
                  :selected="form.people === val"
                  :key="'p' + index"
                  :value="val"
                >
                  {{ val }} {{ $t("text.common.people") }}
                </option>
              </select>
            </div>
            <div class="col-sm-4">
              {{ $t("title.common.type") }}
            </div>
            <div class="col-sm-8 d-flex flex-column flex-sm-row">
              <select id="type" v-model="form.type">
                <option value="0" disabled>
                  {{ $t("title.common.type") }}
                </option>
                <option :selected="form.type === 'hole'" value="hole">
                  {{ $t("title.common.hole") }}
                </option>
                <option :selected="form.type === 'hour'" value="hour">
                  {{ $t("title.common.hour") }}
                </option>
              </select>
            </div>
            <template v-if="form.type === 'hole'">
              <div class="col-sm-4">
                {{ $t("title.common.hole") }}
              </div>
              <div class="col-sm-8 d-flex flex-sm-row">
                <div class="form-check d-inline-block me-3">
                  <input
                    class="form-check-input"
                    type="radio"
                    value="9"
                    id="hole_9"
                    v-model="form.hole"
                    name="hole"
                    :checked="form.hand === '9'"
                  />
                  <label class="form-check-label" for="hole_9"> 9H</label>
                </div>
                <div class="form-check d-inline-block">
                  <input
                    class="form-check-input"
                    type="radio"
                    value="18"
                    id="hole_18"
                    name="hole"
                    v-model="form.hole"
                    :checked="form.hand === '18'"
                  />
                  <label class="form-check-label" for="hole_18">18H</label>
                </div>
              </div>
            </template>

            <template v-if="form.type === 'hour'">
              <div class="col-sm-4">
                {{ $t("title.common.hour") }}
              </div>
              <div class="col-sm-8 d-flex flex-column flex-sm-row">
                <select id="people" v-model="form.hour">
                  <option value="0" disabled>
                    {{ $t("title.common.hour") }}
                  </option>
                  <option
                    v-for="(val, index) in [1, 2, 3, 4, 5, 6]"
                    :selected="form.people === val"
                    :key="'p' + index"
                    :value="val"
                  >
                    {{ val }}{{ $t("title.common.hour") }}
                  </option>
                </select>
              </div>
            </template>
            <div class="col-sm-4">
              {{ $t("title.common.date") }}
            </div>
            <div class="col-sm-8 d-flex flex-column flex-sm-row">
              <div class="row row-cols-2 g-2">
                <div class="col-12">
                  <input
                    type="date"
                    class="form-control-lg"
                    v-model="form.date"
                  />
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              {{ $t("title.common.time") }}
            </div>
            <div class="col-sm-8 d-flex flex-column flex-sm-row">
              <div class="col-12 btn-wrap">
                <button
                  type="button"
                  class="btn btn-outline-primary btn-xs btn-custom"
                  v-for="(val, idx) in reservationinfo.available_slots"
                  :key="'t' + idx"
                  @click="form.time = val.time"
                >
                  {{
                    val.time.split("||")[0] &&
                    $dayjs(val.time.split("||")[0]).format("HH:mm")
                  }}
                  ~
                  {{
                    val.time.split("||")[1] &&
                    $dayjs(val.time.split("||")[1]).format("HH:mm")
                  }}
                </button>
              </div>
            </div>
            <div class="col-sm-4">
              {{ $t("title.common.memo") }}
            </div>
            <div class="col-sm-8 d-flex flex-column flex-sm-row">
              <textarea v-model="form.memo" cols="30" rows="3"></textarea>
            </div>
          </div>
        </b-form>
      </template>
      <!-- 정상 완료 -->
      <template v-if="reservation_flag == '2'">
        <div class="mt-5 mb-4 text-center">
          <p class="material-icons fs-48 text-success">check_circle</p>
          <h6 class="sub-title my-2 pt-1 text-capitalize">
            Reservation completion
          </h6>
          <p class="pt-1 fs-14 lh-sm">Reservation success</p>
        </div>

        <div class="card">
          <div class="card-body px-3 py-2 fs-14">
            <div class="row g-0 table-type header-col p-keep border-0">
              <div class="col-sm-4 bg-transparent">
                {{ $t("title.common.nickname") }}
              </div>
              <div class="col-sm-8">{{ form.nickname }}</div>

              <div class="col-sm-4 bg-transparent">
                {{ $t("title.common.peoples") }}
              </div>
              <div class="col-sm-8 text-price">
                {{ form.people }} {{ $t("text.common.people") }}
              </div>

              <div class="col-sm-4 bg-transparent">
                {{ $t("title.common.reservation_date") }}
              </div>
              <div class="col-sm-8">
                {{ form.date }}
                {{
                  form.time.split("||")[0] &&
                  $dayjs(form.time.split("||")[0]).format("HH:mm")
                }}
                ~
                {{
                  form.time.split("||")[1] &&
                  $dayjs(form.time.split("||")[1]).format("HH:mm")
                }}
              </div>

              <div class="col-sm-4 bg-transparent">
                {{ $t("title.common.memo") }}
              </div>
              <div class="col-sm-8">{{ form.memo }}</div>
            </div>
          </div>
        </div>
      </template>
      <!-- 참가 제한 초과 -->
      <template v-if="reservation_flag == '0'">
        <div class="my-5 text-center">
          <p class="material-icons fs-48 text-orange">report</p>
          <h6 class="sub-title my-2 pt-1 text-capitalize">
            {{ $t("text.common.entry_limit_exceeded") }}
          </h6>
          <p class="pt-1 fs-14 lh-sm">
            {{ $t("text.common.participate_another_tourn") }}
          </p>
        </div>
      </template>
      <!-- 결제 실패 -->
      <template v-if="reservation_flag == '3'">
        <div class="mt-5 mb-4 text-center">
          <p class="material-icons fs-48 text-danger">dangerous</p>
          <h6 class="sub-title my-2 pt-1 text-capitalize">
            {{ $t("text.common.payment_failed") }}
          </h6>
          <p class="pt-1 fs-14 lh-sm">
            {{ $t("text.common.payment_unsuccessful") }}<br />
            {{ $t("text.common.please_try_again") }}
          </p>
        </div>

        <div class="card">
          <div class="card-body px-3 py-2 fs-14">
            <div class="row g-0 table-type header-col p-keep border-0">
              <div class="col-sm-4 bg-transparent">
                {{ $t("text.common.error") }} {{ $t("text.common.code") }}
              </div>
              <div class="col-sm-8">404</div>

              <div class="col-sm-4 bg-transparent">
                {{ $t("text.common.error") }} {{ $t("text.common.reason") }}
              </div>
              <div class="col-sm-8">Card Company Failure</div>
            </div>
          </div>
        </div>
      </template>
      <template #modal-footer>
        <!-- <b-button
          size="md"
          variant="outline-secondary"
          :aria-label="$t('button.common.close')"
          @click="$bvModal.hide('modal-entry-fee-payment')"
        >
          {{ $t("button.common.close") }}
        </b-button> -->

        <!-- <b-button
          size="md"
          variant="outline-secondary"
          :aria-label="$t('button.common.confirm')"
          @click="$bvModal.hide('modal-entry-fee-payment')"
        >
          {{ $t("button.common.confirm") }}
        </b-button> -->

        <b-button
          size="md"
          v-if="reservation_flag == '1'"
          variant="outline-secondary"
          :aria-label="$t('button.common.cancel')"
          @click="$bvModal.hide('modal-reservation')"
        >
          {{ $t("button.common.cancel") }}
        </b-button>

        <b-button
          size="md"
          v-else-if="reservation_flag == '2'"
          variant="outline-secondary"
          :aria-label="$t('button.common.done')"
          @click="$bvModal.hide('modal-reservation')"
        >
          {{ $t("button.common.done") }}
        </b-button>

        <b-button
          size="md"
          v-else
          variant="outline-secondary"
          :aria-label="$t('button.common.close')"
          @click="$bvModal.hide('modal-reservation')"
        >
          {{ $t("button.common.close") }}
        </b-button>

        <b-button
          v-if="reservation_flag == '1'"
          size="md"
          variant="secondary"
          :aria-label="$t('button.common.submit')"
          type="button"
          @click="onSubmit"
        >
          {{ $t("button.common.submit") }}
        </b-button>

        <!-- <b-button
          size="md"
          variant="secondary"
          :aria-label="$t('button.common.try_again')"
        >
          {{ $t("button.common.try_again") }}
        </b-button> -->
      </template>
    </b-modal>
  </div>
</template>

<script>
import location from "@/components/Location";
import ax from "@/api/findlocation";
import "@/filter/common";

export default {
  name: "StoresView",
  components: {
    location,
  },
  data() {
    return {
      searchData: {
        people: 1,
        date: this.$dayjs(new Date()).format("YYYY-MM-DD"),
        hole: 9,
        type: "hole",
        hour: 1,
        time: "",
        memo: "",
      },
      form: {
        shopno: this.$route.params.id,
        people: 1,
        date: this.$dayjs(new Date()).format("YYYY-MM-DD"),
        hole: 9,
        type: "hole",
        hour: 1,
        time: "",
        memo: "",
      },
      reservationinfo: {},
      shopno: this.$route.params.id,
      shopinfo: [],
      login: sessionStorage.getItem("token") ? true : false,
      reservation_flag: 1,
    };
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();

      ax.post_reservationwrite(this.shopno, this.form, (flag, data) => {
        if (flag) {
          if (data.code === 200) {
            // this.$bvModal.hide("modal-reservation");
            this.reservation_flag = 2;
          }
        } else {
          alert(data.message);
          // this.reservation_flag = 3;
          return false;
        }
      });
    },
    reservation() {
      if (!this.login) {
        this.$bvToast.show("toast-require-login");
        return false;
      }

      this.form = {
        shopno: this.$route.params.id,
        people: 1,
        date: this.$dayjs(new Date()).format("YYYY-MM-DD"),
        hole: 9,
        type: "hole",
        hour: 1,
        time: "",
        memo: "",
      };
      this.get_reservation_info();
      this.$bvModal.show("modal-reservation");
    },

    get_reservation_info() {
      ax.get_reservation_info(this.shopno, this.form, (flag, data) => {
        // console.log(flag, data);
        if (flag) {
          this.reservationinfo = data.reservation_info;
          this.form = {
            ...this.form,
            nickname: this.reservationinfo.nickname,
            email: this.reservationinfo.email,
          };
          this.reservation_flag = 1;
        } else {
          this.reservationinfo.available_slots = [];
          this.reservation_flag = 1;
          alert(data.message);
        }
      });
    },
    get_shopinfo() {
      ax.get_shopinfo(this.shopno, (flag, data) => {
        if (flag) {
          this.shopinfo = data.shopinfo;
        } else {
          alert(data);
        }
      });
    },
    goToLogin() {
      this.$router.push("/login");
    },
  },
  watch: {
    "form.people": function () {
      this.get_reservation_info();
    },
    "form.date": function () {
      this.get_reservation_info();
    },
    "form.hole": function () {
      this.get_reservation_info();
    },
    "form.type": function () {
      this.get_reservation_info();
    },

    "form.hour": function () {
      this.get_reservation_info();
    },
  },
  created() {
    this.get_shopinfo();
  },
};
</script>
<style>
.btn-wrap {
  display: grid;
  grid-template-columns: repeat(2, 2fr);
  gap: 10px;
}

.btn-custom {
  border: 1px solid #cdcfd1;
  padding: 12px 10px;
  height: auto;
  line-height: 1;

  &:hover,
  &:focus {
    background: #00b34b;
    border: 1px solid #00b34b;
  }
}
</style>
